import React from 'react';
import { connect } from 'react-redux';
import { bulkActionsArchive } from 'actions/shared/index/bulk';

class ArchiveView extends React.Component {
  render() {
    return (
      <div>
        <div className="BulkAction-viewHeader">
          {I18n.t('archive.bulk_actions.archive_content')}
        </div>
        <div className="BulkAction-viewContent">
          {I18n.t('archive.bulk_actions.confirmation_message', {
            count: this.props.selectedCount,
          })}
        </div>
        <div className="BulkAction-viewButtonContainer d-f jc-e ai-c">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
          <div className="mr-12 c-p" onClick={this.props.toggleMenu}>
            {I18n.t('common.cancel')}
          </div>
          <button
            type="button"
            className="NewButton NewButton-flat"
            onClick={this.props.bulkActionsArchive}
          >
            {I18n.t('archive.bulk_actions.confirm')}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedCount: state.bulk.selected.length,
});

const mapDispatchToProps = { bulkActionsArchive };

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveView);
